import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleearthComponent } from './simple-icons-googleearth.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleearthComponent ],
    exports:      [ SimpleIconsGoogleearthComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleearthModule {}
